export default "__VITE_ASSET__CYOflrXW__"